import { render, staticRenderFns } from "./OldGuiFrame.vue?vue&type=template&id=1b5f3943&scoped=true&"
import script from "./OldGuiFrame.vue?vue&type=script&lang=js&"
export * from "./OldGuiFrame.vue?vue&type=script&lang=js&"
import style0 from "./OldGuiFrame.vue?vue&type=style&index=0&id=1b5f3943&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5f3943",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
